import { CustomerCard } from "@/react/features/customer/card";
import PageLayout from "@/react/features/styled/PageLayout";
import TokenGeneratorContent from "@/react/features/token-generator/TokenGeneratorContent";

const TokenGeneratorPage = () => {
  return (
    <PageLayout>
      <CustomerCard />
      <TokenGeneratorContent />
    </PageLayout>
  );
};

export default TokenGeneratorPage;
